(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_announcement"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__announcementBarLinkScrollBound) return;
    window.__announcementBarLinkScrollBound = true;

    document.addEventListener('click', function (event) {
      var link = event.target instanceof Element ? event.target.closest('.announcement-bar__link') : null;
      if (!link) return;

      var hash = link.getAttribute('href') || '';
      if (hash.charAt(0) !== '#' || hash.length < 2) return;

      var targetId = decodeURIComponent(hash.slice(1));
      var target = document.getElementById(targetId);
      if (!target) return;

      event.preventDefault();

      target.scrollIntoView({ behavior: 'smooth', block: 'center' });

      if (window.history && window.history.pushState) {
        window.history.pushState(null, '', hash);
      } else {
        window.location.hash = hash;
      }

      window.setTimeout(function () {
        if (typeof target.focus === 'function') {
          target.focus({ preventScroll: true });
        }
      }, 450);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
